import React, { useEffect, useState } from 'react';
import axios from 'axios';
const OutwardRegister = () => {
  const [outwardIds, setOutwardIds] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [docTypeFilter, setDocTypeFilter] = useState('Bonafide');
  const language = localStorage.getItem('language')
  const [heading, setHeading] = useState('');
  const [logoURL, setLogoURL] = useState(null);
  const [schoolData, setSchoolData] = useState(null);
  const userstatus = localStorage.getItem('userStatus')

  const udiseNumber = localStorage.getItem("udiseNumber");
  const outwardUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/outwardIds.json`;
  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };

  const fetchStudentData = async () => {
    try {
      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const allRecords = objectStore.getAll();

      return new Promise((resolve, reject) => {
        allRecords.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            const filteredData = data.filter(student => student !== null);
            resolve(filteredData);
          } else {
            resolve([]);
          }
        };

        allRecords.onerror = (event) => {
          console.error('Error fetching student data from IndexedDB:', event.target.error);
          reject('Error fetching student data');
        };
      });
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  };

  useEffect(() => {
    const fetchOutwardIds = async () => {
      try {
        const response = await fetch(outwardUrl);
        if (!response.ok) {
          throw new Error('Failed to fetch outward IDs');
        }
        const data = await response.json();
        // Ensure data is an object before using Object.keys
        if (data && typeof data === 'object') {
          const outwardIdsArray = Object.keys(data).map(key => ({
            id: key,
            ...data[key],
          }));
          console.log("Fetched outward IDs:", outwardIdsArray); // Debug log
          setOutwardIds(outwardIdsArray);
        } else {
          console.log("No outward IDs data found or data is not an object.");
          setOutwardIds([]); // Set empty array if no valid data
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchOutwardIds();
    fetchStudentData().then(setStudentData).catch(setError);
  }, [outwardUrl]);



  const fetchSchoolData = async () => {
    if (udiseNumber) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
            setLogoURL(data.schoolLogo);
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };

  useEffect(() => {
    fetchSchoolData();
  }, [udiseNumber]);

  const filteredOutwardIds = Array.isArray(outwardIds) ? outwardIds.filter(item => item.id !== 'current') : [];

  useEffect(() => {
    let title = '';
    if (docTypeFilter === 'Bonafide') {
      title = language === 'English' ? 'Bonafide Outward Register' : 'बोनाफाईड जावक रजिस्टर';
    } else if (docTypeFilter === 'Leaving Certificate') {
      title = language === 'English' ? 'Leaving Certificate Outward Register' : 'शाळा सोडल्याचा जावक रजिस्टर';
    } else if (docTypeFilter === 'Shifaras Form') {
      title = language === 'English' ? 'Shifaras Form Outward Register' : 'शिफारस फॉर्म जावक रजिस्टर';
    } else if (docTypeFilter === 'Form 15A') {
      title = language === 'English' ? 'Form 15A Outward Register' : 'फॉर्म १५अ जावक रजिस्टर';
    }
    setHeading(title);
  }, [docTypeFilter, udiseNumber, language]);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    console.log("error-", error);

    return <p>Error: {error}</p>;
  }


  const studentMap = studentData.reduce((acc, student) => {
    if (!student) return acc;
    const keyParts = student.id ? student.id.split('-') : [];
    const idSerialNo = keyParts.length > 0 ? keyParts[keyParts.length - 1] : null;
    
    const name = ((student.stdName || '').trim() + " " + (student.stdFather || '').trim() + " " + (student.stdSurname || '').trim()).trim() || '-';
    const info = {
      name: name,
      class: student.currentClass || '-',
      registerNo: student.registerNo || '-'
    };

    const hasValidName = name && name !== '-';

    // First pass: serialNo / idSerialNo matches
    if (idSerialNo) {
      const k = String(idSerialNo).trim();
      if (k && (!acc[k] || (hasValidName && (!acc[k].name || acc[k].name === '-')))) {
        acc[k] = info;
      }
    }
    if (student.serialNo) {
      const k = String(student.serialNo).trim();
      if (k && (!acc[k] || (hasValidName && (!acc[k].name || acc[k].name === '-')))) {
        acc[k] = info;
      }
    }

    return acc;
  }, {});

  // Second pass: registerNo matches (fallback)
  studentData.forEach(student => {
    if (!student || !student.registerNo) return;
    const regKey = String(student.registerNo).trim();
    if (!regKey) return;

    const name = ((student.stdName || '').trim() + " " + (student.stdFather || '').trim() + " " + (student.stdSurname || '').trim()).trim() || '-';
    const info = {
      name: name,
      class: student.currentClass || '-',
      registerNo: student.registerNo || '-'
    };

    const hasValidName = name && name !== '-';
    const existing = studentMap[regKey];

    if (!existing || (!existing.name || existing.name === '-') || (hasValidName && (!existing.name || existing.name === '-'))) {
      if (hasValidName) {
        studentMap[regKey] = info;
      } else if (!existing) {
        studentMap[regKey] = info;
      }
    }
  });




  const filteredOutwardIdsByDocType = filteredOutwardIds.filter(item => {
    if (docTypeFilter === 'Bonafide') {
      return item.documentNumber && item.documentNumber.startsWith('BONAFIDE');
    }
    if (docTypeFilter === 'Leaving Certificate') {
      return item.documentNumber && item.documentNumber.startsWith('LC');
    }
    if (docTypeFilter === 'Shifaras Form') {
      return (item.documentNumber && item.documentNumber.startsWith('SHIFARAS')) || (item.reason && item.reason.toLowerCase().includes('shifaras'));
    }
    if (docTypeFilter === 'Form 15A') {
      return (item.documentNumber && item.documentNumber.startsWith('FORM15A')) || (item.reason && item.reason.toLowerCase().includes('form 15a'));
    }
    return true;
  });

  const handlePrint = () => {
    const printContent = document.getElementById('print-content'); // Use getElementById for better specificity

    if (printContent) {
      const cloneContent = printContent.cloneNode(true); // Clone the main content

      // Open a new window for printing
      const printWindow = window.open('', '', 'height=800,width=1000');
      printWindow.document.write(`
        <html>
          <head>
            <style>
              @page {
                size: A4 landscape;
                margin: 3mm;
                padding: 15px;
                border: 1px solid black;
              }
              body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 0;
              }
              table {
                border-collapse: collapse;
                width: 100%;
                font-size: 16px;
              }
              th, td {
                border: 1px solid black;
                text-align: center;
                padding: 5px;
              }
              td {
                font-size: 16px;
              }
              th {
                background-color: #82CAFA;
              }
              .print-button {
                display: none;
              }
              .school-header-container {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
              }
              .school-header2 {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex: 0 0 auto; /* Prevent this section from growing */
                margin-right: 10px;
              }
              .school-header2 img {
                max-height: 70px;
              }
              .school-header {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center; margin-left:-70px;
                flex: 1 1 auto; /* This makes the school header take available space */
              }
              .school-header h1 {
                font-size: 28px;
                margin: 5px 0;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .school-header .report-title {
                font-size: 20px;
                margin: 5px auto;
                font-weight: bold;
                padding: 5px;
                text-align: center;
                border-radius: 10px;
                background-color: black;
                color: white;
                display: inline-block; 
              }
              .school-header .report-tit {
                font-size: 16px;
                margin: 5px auto;
                font-weight: bold;
                text-align: center;
              }
                
            </style>
          </head>
          <body>
            <div class="school-header-container">
             <div class="school-header2">
                  ${logoURL ? `<img src="${logoURL}" alt="School Logo">` : '<div></div>'}
                </div>
                <div class="school-header">
                  <div style="margin-left: 15px;">
                    <h1>${schoolData.schoolName}</h1>
                    <div class="report-tit">
                      ${language === 'English' ? 'Taluka' : 'तालुका'} ${schoolData.taluka}, ${language === 'English' ? 'District' : 'जिल्हा'} : ${schoolData.jilha}
                    </div>
                    <div class="report-title">
                      ${heading} <!-- Use heading directly -->
                    </div>
                  </div>
                </div>
              </div>
              <style>
                .styled-table {
                  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                }
              </style>
              ${cloneContent.outerHTML}
            </body>
  
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    } else {
      console.error('Content to print not found');
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this record?");
    if (confirmDelete) {
      try {
        const response = await axios.delete(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/outwardIds/${id}.json`);
        if (response.status === 200) {
          setOutwardIds(prevIds => prevIds.filter(outward => outward.id !== id)); // Update state to remove the deleted ID
          alert("Record deleted successfully!");
        } else {
          alert("Failed to delete the record.");
        }
      } catch (error) {
        console.error("Error deleting record:", error);
        alert("An error occurred while deleting the record.");
      }
    }
  };



  return (
    <div className='main-content-of-page'>

      <button onClick={handlePrint} className="btn btn-primary float-end" style={{ marginBottom: '5px' }}>Print</button>

      <div style={{ marginBottom: '40px', display: 'flex', alignItems: 'center', marginRight: '20px', float: 'left', marginTop: '20px', backgroundColor: 'rgb(215 227 241)', padding: '10px', borderRadius: '10px', boxShadow: ' 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)' }}>
        <label style={{ marginRight: '15px' }}>
          <input
            type="radio"
            name="docType"
            value="Bonafide"
            checked={docTypeFilter === 'Bonafide'} style={{ width: 'auto' }}
            onChange={() => setDocTypeFilter('Bonafide')}
          />
          Bonafide
        </label>
        <label style={{ marginRight: '15px' }}>
          <input
            type="radio"
            name="docType"
            value="Leaving Certificate" style={{ width: 'auto' }}
            checked={docTypeFilter === 'Leaving Certificate'}
            onChange={() => setDocTypeFilter('Leaving Certificate')}
          />
          Leaving Certificate
        </label>
        <label style={{ marginRight: '15px' }}>
          <input
            type="radio"
            name="docType"
            value="Shifaras Form" style={{ width: 'auto' }}
            checked={docTypeFilter === 'Shifaras Form'}
            onChange={() => setDocTypeFilter('Shifaras Form')}
          />
          Shifaras Form
        </label>
        <label>
          <input
            type="radio"
            name="docType"
            value="Form 15A" style={{ width: 'auto' }}
            checked={docTypeFilter === 'Form 15A'}
            onChange={() => setDocTypeFilter('Form 15A')}
          />
          Form 15A
        </label>
      </div>
      <br />
      <br />
      <br />

      <h3 className='text-center mb-2' style={{ color: '#03365e', fontWeight: '600', width: '80%' }}> {heading} </h3>
      <div id='print-content'>


        <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
          <colgroup>
            <col style={{ width: '70px' }} />
            <col style={{ width: '110px' }} />
            <col style={{ width: '120px' }} />
            <col style={{ width: '90px' }} />
            <col style={{ width: 'auto' }} />
            <col style={{ width: '110px' }} />
            <col style={{ width: '200px' }} />
            <col style={{ width: 'auto' }} />
          </colgroup>

          <thead>
            <tr style={{ backgroundColor: '#c6e1ff', textAlign: 'left' }}>
              <th style={{ padding: '10px', border: '1px solid black' }}>
                {language === "English" ? 'Sr. No.' : 'अनु. क्र.'}
              </th>
              <th style={{ padding: '10px', border: '1px solid black' }}>
                O. W. ID
              </th>
              <th style={{ padding: '10px', border: '1px solid black' }}>
                {language === "English" ? 'Date' : 'दिनांक'}
              </th>
              <th style={{ padding: '10px', border: '1px solid black' }}>
                {language === "English" ? 'Reg. No.' : 'रजि. क्र'}
              </th>
              <th style={{ padding: '10px', border: '1px solid black' }}>
                {language === "English" ? 'Student Name' : 'विद्यार्थ्याचे नाव'}
              </th>
              <th style={{ padding: '10px', border: '1px solid black' }}>
                {language === "English" ? 'Class' : 'वर्ग'}
              </th>
              <th style={{ padding: '10px', border: '1px solid black' }}>
                {language === "English" ? 'Document Number' : 'दस्तऐवज क्रमांक'}
              </th>
              <th style={{ padding: '10px', border: '1px solid black' }}>
                {language === "English" ? 'Reason' : 'कारण'}
              </th>
              {userstatus === "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764" && (
                <th style={{ padding: '10px', border: '1px solid black' }}>{language === "English" ? 'Action' : 'कृती'}</th>
              )}

            </tr>
          </thead>
          <tbody>
            {filteredOutwardIdsByDocType && filteredOutwardIdsByDocType.length > 0 ? (
              filteredOutwardIdsByDocType.map((item, index) => {
                const studentInfo = studentMap[item.serialNo] || {};
                return (
                  <tr key={item.id} style={{ borderBottom: '1px solid #ddd', backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9', cursor: 'pointer' }}>
                    <td style={{ padding: '10px', textAlign: 'center' }}>{index + 1}</td>
                    <td style={{ padding: '10px' }}>{item.id}</td>
                    <td style={{ padding: '10px' }}>{item.date || ' '}</td>
                    <td style={{ padding: '10px' }}>{studentInfo.registerNo || ' '}</td>
                    <td style={{ padding: '10px' }}>{studentInfo.name || ' '}</td>
                    <td style={{ padding: '10px' }}>{studentInfo.class || ' '}</td>
                    <td style={{ padding: '10px' }}>{item.documentNumber || ' '}</td>
                    <td style={{ padding: '10px' }}>{item.reason || ' '}</td>
                    {userstatus === "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764" && (
                      <td style={{ padding: '10px' }}>
                        <button onClick={() => handleDelete(item.id)} style={{ color: 'red', border: 'none', background: 'none', cursor: 'pointer' }}>
                          Delete
                        </button>
                      </td>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td style={{ padding: '10px', textAlign: 'center' }} colSpan="9">
                  {language === 'English' ? 'No records to display' : 'दाखविण्यासाठी कोणतेही रेकॉर्ड नाहीत'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <style jsx>{`
  th{
  width:auto;
    text-align: center;
    font-weight: bold !important;
    background-color: #c6e1ff !important;
  }
  td{
  border:1px solid black;
  width:auto;
  }
`}</style>
    </div>
  );
};

export default OutwardRegister; 